import apiService from './apiService';

const CATEGORIES_PREFIX = '/categories';

export const categoryService = {
  // Lấy toàn bộ danh sách danh mục
  getAllCategories: () => apiService.get(CATEGORIES_PREFIX),

  getHierarchicalCategories: () => apiService.get(`${CATEGORIES_PREFIX}/hierarchical`),
  
  // Lấy chi tiết danh mục theo ID
  getCategoryById: (id) => apiService.get(`${CATEGORIES_PREFIX}/${id}`),

  // Thêm mới danh mục
  createCategory: (data) => apiService.post(CATEGORIES_PREFIX, data),

  // Cập nhật danh mục
  updateCategory: (id, data) => apiService.put(`${CATEGORIES_PREFIX}/${id}`, data),

  // Xóa danh mục
  deleteCategory: (id) => apiService.delete(`${CATEGORIES_PREFIX}/${id}`),

  // Upload ảnh lên Cloudinary qua Backend
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiService.post(`${CATEGORIES_PREFIX}/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
